import React, { useEffect } from 'react';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Description } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from '@tanstack/react-router';
import { DataGrid } from '@mui/x-data-grid';
import { actions } from '../PatientView.redux';
import PatientReportsCell from './PatientReportsCell';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';

const PatientReports = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { patient_id } = useParams({ from: '/patients/view/$patient_id' });
    const hasLoaded = useSelector((state) => state.patientView.reportsPreviouslyLoaded);
    const loading = useSelector((state) => state.patientView.reportsLoading);
    const reports = useSelector((state) => state.patientView.reports);
    const loadReports = (patientID) => dispatch(actions.loadReports(patientID));

    const columns = [
        { field: 'urpt_name', headerName: 'Report Name', flex: 1, minWidth: 180, sortable: false },
        { field: 'date_created', headerName: 'Report Date', flex: 1, minWidth: 150, sortable: false },
        { field: 'date_updated', headerName: 'Last Updated', flex: 1, minWidth: 150, sortable: false },
        { field: 'template_name', headerName: 'Report Template', flex: 1, minWidth: 180, sortable: false },
        { field: 'created_by', headerName: 'Created By', flex: 1, minWidth: 150, sortable: false },
        { field: 'updated_by', headerName: 'Updated by', flex: 1, minWidth: 150, sortable: false },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => <PatientReportsCell {...params} />,
        },
    ];

    useEffect(() => {
        if (!hasLoaded && !loading) {
            loadReports(patient_id);
        }
    }, [loadReports, patient_id, hasLoaded, loading]);

    return (
        <DashboardCard
            color={'amber'}
            icon={<Description />}
            topContent={'Reports'}
            topLabel="Click a report to view or edit"
            size="xl"
        >
            <div style={{ width: '100%' }}>
                <DataGrid
                    rows={reports}
                    columns={columns}
                    getRowId={(row) => row.urpt_id}
                    pagination
                    pageSizeOptions={[5, 10, 20, 50]}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    loading={loading}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableCellFocus
                    sx={{
                        '& .MuiDataGrid-row': { cursor: 'pointer' },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        },
                    }}
                    slots={{ pagination: NumberedDataGridPagination }}
                    onRowClick={(params) => {
                        if (params.field !== 'actions') {
                            navigate({ to: `/reports/edit/${params.row.urpt_id}` });
                        }
                    }}
                    autoHeight
                />
            </div>
        </DashboardCard>
    );
};

export default PatientReports;
